<template>
  <div>
    <cart-bundle :cart-item="cartItem" :inCart="false" :unavailable="false">
    </cart-bundle>
  </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import CartBundle from '@/components/webshop/cart/CartBundle.vue'
export default {
  mixins: [webshopMixins],
  props: ["product", "cartItem"],
  components: {
    // Discount,,
    CartBundle
    // GlobalStripePaymentForm,
    // ThanksForOrder
  },
}
</script>